export default __webpack_public_path__ + "static/media/transactions.6e09659c.png";